<script>

// ---------------- component not used yet -------------------------------

import TradingVue from "trading-vue-js";
import CandlesWithDeals from "@/Charts/Candles.vue";
import helperMethods from "@/helpers";
export default {
    props:{
        deals: Array,
        candles: Array,
        indicator: Array,
        pair: Object,
    },
    components:{
        TradingVue, CandlesWithDeals
    },
    data(){
        return {
            chart_width: window.innerWidth - 120
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },
    computed:{
        data_chart(){
            return {
                ohlcv: this.ohlcvFromCandles(this.candles),
                onchart:[
                    {
                        name: "Deals",
                        type: "Trades",
                        data: this.deals_data,
                        settings: {
                            markerSize: 3
                        }
                    }
                ]
            }
        },
        deals_data(){
            let data = [];
            this.deals.filter((deal)=>deal.completed_at).forEach((deal)=>{
                data.push([
                    this.timestamp(deal.started_at), 1, deal.rate_started, deal.token
                ]);
                data.push([
                    this.timestamp(deal.completed_at), 0, deal.rate_completed, deal.token
                ]);
            })
            return data;
        },
    },
    methods:{
        ... helperMethods,
        onResize(event) {
            this.chart_width = window.innerWidth - 120;
        }
    }
}
</script>


<template>
    <div class="w-full" id="chart_container">
        <CandlesWithDeals
            :candles="candles"
            :deals="deals"
            :pair="pair.symbol"
            :candlesChartData="candlesChartData"
            :dealsChartData="dealsChartData"
            :width="1000"

        />
    </div>
</template>

